"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/productViewModel',["require", "exports", "knockout", "messenger"], function (require, exports, ko, messenger) {
    "use strict";

    var ProductViewModel = function () {
        function ProductViewModel() {
            var _this = this;

            _classCallCheck(this, ProductViewModel);

            this.products = [{ key: 'iTelematiX', value: 'itelematix' }, { key: 'FourFive', value: 'fourfive' }];
            this.selectedProduct = ko.observable(null);
            messenger.on('identity:logout', function () {
                _this.reset();
            });
        }

        _createClass(ProductViewModel, [{
            key: "reset",
            value: function reset() {
                this.selectedProduct(null);
            }
        }]);

        return ProductViewModel;
    }();

    return new ProductViewModel();
});
//# sourceMappingURL=productViewModel.js.map;
